<template>
  <div id="app" :class="$isEmbed ? 'embed-app' : ''">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  };
</script>

<style lang="less">
  // 这个页面是在 iframe 中加载，不会影响项目中的整体布局
  #app {
    min-width: 0;
  }

  // vhall-jssdk-doc-3.4.7 页面底部插入了一个一像素高元素，影响一屏页面，不知作用是啥，先隐藏
  #myVodNode {
    height: 0px !important;
  }
</style>
